// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.
//
// Site → Floor Plan. The screen is the only layer that talks to services: it
// fetches the plan geometry and the plant readouts and hands them to the
// presentational tree, so binding either to the digital twin is a service
// swap rather than a component rewrite.

import React from 'react';
import { useParams } from 'react-router-dom';
import { useCriticalSystems, useFloorPlanLayout } from '../../hooks/useAlarms';
import { PageHead } from '../../components/shell/ScreenHelpers';
import SiteTabs from '../../components/shell/SiteTabs';
import FloorPlanFrame from '../../components/floor-plan/FloorPlanFrame';
import FloorPlanGraphic from '../../components/floor-plan/plan/FloorPlanGraphic';
import CriticalSystemsPanel from '../../components/floor-plan/CriticalSystemsPanel';
import './FloorPlanScreen.css';

/**
 * Both bands keep the shape the design gave them whether or not data exists.
 * Nothing here is seeded: the plan drawing and the plant readouts each render a
 * state that names the contract behind them, so the screen doubles as the record
 * of what still needs wiring. See components/floor-plan/missingData.ts.
 */
export default function FloorPlanScreen() {
  const { site_id } = useParams();
  const siteId = site_id ?? '';
  const { criticalSystems, loading } = useCriticalSystems(siteId);
  const { layout, loading: layoutLoading } = useFloorPlanLayout(siteId);

  return (
    <div className="hs-screen">
      <SiteTabs />
      <div className="hs-screen-body">
        <PageHead title="Floor Plan" />

        <FloorPlanFrame loading={layoutLoading}>
          {layout && !layoutLoading ? <FloorPlanGraphic layout={layout} /> : null}
        </FloorPlanFrame>

        <CriticalSystemsPanel data={loading ? null : criticalSystems} />
      </div>
    </div>
  );
}
